import styled from "styled-components";

export const PageTitle = styled.span`
  font-weight: bold;
  font-size: 1.67em;
  color: #434452;
  margin: 0;
`;
